import React, { useCallback, useMemo, useState } from "react";
import { Button, Input, Row, Col } from "antd";
import CustomModal from "../components/CustomModal";
import {showNotification} from "../utils/commonFunctions";


const AddNewTenant = (props) => {
  const { visible, handleModal, onUserInvite } = props;
  const [state, setState] = useState({});
  const [formError, setFormError] = useState({
    organization_name: null,
    email: null,
    password: null,
  });

  // ✅ Basic client-side validation
  const hasError = useCallback(() => {
    let { organization_name, email, password } = state;
    let error = {};

    organization_name = organization_name?.trim();
    if (!organization_name) {
      error.organization_name = "Please enter organization name";
    }

    email = email?.trim();
    if (!email) {
      error.email = "Please enter email";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      error.email = "Please enter a valid email";
    }

    if (!password) {
      error.password = "Please enter password";
    }

    setFormError(error);
    return !!Object.keys(error).length;
  }, [state]);

  const handleChange = useCallback(
    (name) => (event) => {
      let value = event?.target?.value ?? event?.target?.checked;

      setFormError((prev) => ({ ...prev, [name]: null })); // clear error for field
      setState((pre) => ({
        ...pre,
        [name]: value,
      }));
    },
    []
  );

  let { password, organization_name, email } = state;

 const onOk = useCallback(async () => {
  if (!hasError()) {
    setState((pre) => ({
      ...pre,
      loading: true,
    }));

    let newUser = {
      organization_name,
      email,
      password,
    };

    try {
      const resp = await onUserInvite(newUser);
      console.log('User invite successful:', resp);
      
      // Reset form after successful submission
      setState({});
      setFormError({
        organization_name: null,
        email: null,
        password: null,
      });
      
      // Optional: Show success notification
      showNotification("success", "Tenant added successfully!");
      
    } catch (err) {
      console.log('Error in onOk:', err);

      // Handle field-specific validation errors first
      let backendErrors = {};
      let hasFieldErrors = false;
      
      if (err?.detail && Array.isArray(err.detail)) {
        err.detail.forEach((error) => {
          if (error.loc?.includes("organization_name")) {
            backendErrors.organization_name = error.msg;
            hasFieldErrors = true;
          }
          if (error.loc?.includes("email")) {
            backendErrors.email = error.msg;
            hasFieldErrors = true;
          }
          if (error.loc?.includes("password")) {
            backendErrors.password = error.msg;
            hasFieldErrors = true;
          }
        });
      }
      
      if (hasFieldErrors) {
        // Show field-specific errors under the form fields
        setFormError(backendErrors);
      } else {
        // Show general error as notification
        const errorMessage = 
          err?.message || 
          err?.detail || 
          (typeof err === 'string' ? err : 'Failed to add tenant');
        
        showNotification("error", errorMessage);
      }
    } finally {
      setState((pre) => ({ ...pre, loading: false }));
    }
  }
}, [organization_name, email, password, hasError, onUserInvite]);


  const renderFooter = useMemo(() => {
    return (
      <Row className="p10">
        <Button
          className="new_button"
          type="primary"
          size="large"
          onClick={onOk}
          loading={state.loading}
        >
          Add
        </Button>
        <Button
          className="new_button"
          onClick={handleModal}
          size="large"
        >
          Cancel
        </Button>
      </Row>
    );
  }, [handleModal, onOk, state.loading]);

  return (
    <CustomModal
      visible={visible}
      title={"Add New Tenant"}
      footer={renderFooter}
      onCancel={props?.handleModal}
    >
      <div>
        <Col className="mb10">
          <Col className="mb5">
            <label className="label">Organization Name</label>
            <sup style={{ color: "red" }}>*</sup>
          </Col>
          <Col>
            <Input
              size="large"
              type="text"
              value={organization_name}
              placeholder="Enter organization name"
              onChange={handleChange("organization_name")}
            />
            <Row className="error mt5">{formError?.organization_name}</Row>
          </Col>
        </Col>

        <Col className="mb10">
          <Col className="mb5">
            <label className="label">Email</label>
            <sup style={{ color: "red" }}>*</sup>
          </Col>
          <Col>
            <Input
              size="large"
              type="email"
              value={email}
              placeholder="Enter email"
              onChange={handleChange("email")}
            />
            <Row className="error mt5">{formError?.email}</Row>
          </Col>
        </Col>

        <Col>
          <Col className="mb5">
            <label className="label">Password </label>
            <sup style={{ color: "red" }}>*</sup>
          </Col>
          <Col>
            <Input.Password
              placeholder="**********"
              value={password}
              onChange={handleChange("password")}
              size="large"
              allowClear
            />
            <Row className="error mt5">{formError?.password}</Row>
          </Col>
        </Col>
      </div>
    </CustomModal>
  );
};

export default AddNewTenant;

